/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PopupConfigInfoRespVo
 */
export interface PopupConfigInfoRespVo {
    /**
     * 横坐标
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    xCoordinate?: number;
    /**
     * 纵坐标
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    yCoordinate?: number;
    /**
     * 数据编号
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    id?: number;
    /**
     * 标题
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    title?: string;
    /**
     * 内容（韩文）
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    content?: string;
    /**
     * 内容（中文）
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    contentCn?: string;
    /**
     * 开始日期
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    beginDate?: string;
    /**
     * 结束日期
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    endDate?: string;
    /**
     * 宽度
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    width?: number;
    /**
     * 高度
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    height?: number;
    /**
     * 是否居中：0-不居中，1-居中
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    center?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    enable?: number;
    /**
     * 链接地址
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    url?: string;
    /**
     * 是否显示：0-不显示，1-显示
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    show?: number;
    /**
     * 是否当前窗口打开：0-不在当前窗口，1-在当前窗口
     * @type {number}
     * @memberof PopupConfigInfoRespVo
     */
    selfWindow?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof PopupConfigInfoRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the PopupConfigInfoRespVo interface.
 */
export function instanceOfPopupConfigInfoRespVo(value: object): value is PopupConfigInfoRespVo {
    return true;
}

export function PopupConfigInfoRespVoFromJSON(json: any): PopupConfigInfoRespVo {
    return PopupConfigInfoRespVoFromJSONTyped(json, false);
}

export function PopupConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopupConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'xCoordinate': json['xCoordinate'] == null ? undefined : json['xCoordinate'],
        'yCoordinate': json['yCoordinate'] == null ? undefined : json['yCoordinate'],
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'contentCn': json['contentCn'] == null ? undefined : json['contentCn'],
        'beginDate': json['beginDate'] == null ? undefined : json['beginDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'center': json['center'] == null ? undefined : json['center'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'url': json['url'] == null ? undefined : json['url'],
        'show': json['show'] == null ? undefined : json['show'],
        'selfWindow': json['selfWindow'] == null ? undefined : json['selfWindow'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function PopupConfigInfoRespVoToJSON(json: any): PopupConfigInfoRespVo {
    return PopupConfigInfoRespVoToJSONTyped(json, false);
}

export function PopupConfigInfoRespVoToJSONTyped(value?: PopupConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'xCoordinate': value['xCoordinate'],
        'yCoordinate': value['yCoordinate'],
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
        'contentCn': value['contentCn'],
        'beginDate': value['beginDate'],
        'endDate': value['endDate'],
        'width': value['width'],
        'height': value['height'],
        'center': value['center'],
        'enable': value['enable'],
        'url': value['url'],
        'show': value['show'],
        'selfWindow': value['selfWindow'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

